export { default } from "./src/tabs-12-col";
// @ts-ignore
export type { UniformTabs12ColProps } from "./src/tabs-12-col";
